import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    // paddingTop: theme.spacing(),
    // padding: theme.spacing(3),
    minWidth: '50%',
    maxWidth: '822px',
  },
  topBar: {
    backgroundColor: '#F6F6F6',
    padding: '20px 24px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '133.4%',
    color: '#000000',
  },
  text: {
    width: '100%',
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    fontSize: 15,
    color: 'black',
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  container: {},
  flexBox: {
    display: 'flex',
    padding: '24px',
  },
  profileContainer: {
    marginRight: 32,
    width: 192,
  },
  formContainer: {
    marginRight: 32,
    flex: 1,
  },
}));
